<div class="live-view-root">
  <div class="main-layout">

    <!-- ── LEFT: Recorded Actions ──────────────────────────────────────────── -->
    <div class="left-panel">
      <ze-recorded-actions
        [recordedSteps]="recordedSteps"
        [isRecording]="isRecording"
        [currentStepName]="currentStepName"
        (stepsCleared)="onStepsCleared()"
        (stepCleared)="onStepCleared($event)"
        (stepRemoved)="onStepRemoved($event)"
        (stepRenamed)="onStepRenamed($event)"
        (actionRemoved)="onActionRemoved($event)"
        (verifyElement)="onVerifyElement($event)">
      </ze-recorded-actions>
    </div>

    <!-- ── CENTER: Device Screen ───────────────────────────────────────────── -->
    <div class="device-col">
      <ze-device-screen
        #deviceScreen
        [step]="step"
        [fingerMode]="fingerMode"
        [selectedMode]="selectedMode"
        [isRecording]="isRecording && !isPaused"
        [uploadedAppName]="uploadedAppName"
        [isFetchingLocator]="isFetchingLocator"
        [isModalOpen]="isModalOpen"
        (stepChange)="onStepChange($event)"
        (streamError)="onStreamError($event)"
        (actionCaptured)="onActionCaptured($event)"
        (locatorFetchingChange)="onLocatorFetchingChange($event)"
        (contextMenuAction)="onContextMenuAction($event)"
        (endSession)="reset()"
        (typeRequested)="onTypeRequested($event)">
        <ng-container slot="end-button" *ngIf="step === 'streaming'">
          <!-- <span class="driver-badge"
                [class.driver-badge--flutter]="session.activeDriver === 'flutter-integration'">
            {{ session.activeDriver === 'flutter-integration' ? 'Flutter' : 'Native' }}
          </span> -->
          <label class="uninstall-toggle" title="Uninstall app when session ends">
            <input type="checkbox" [(ngModel)]="uninstallOnEnd" [disabled]="isEndingSession" [featureActionState]="'MOBILE_AUTOMATION'" />
            <span class="uninstall-toggle-label">Uninstall on end</span>
          </label>
          <button class="btn-end" (click)="reset()" [disabled]="isEndingSession" [featureActionState]="'MOBILE_AUTOMATION'">
            <span *ngIf="!isEndingSession">⏹ End Session</span>
            <span *ngIf="isEndingSession" class="btn-end-spinner"></span>
            <span *ngIf="isEndingSession">Ending…</span>
          </button>
        </ng-container>
      </ze-device-screen>
    </div>

    <!-- ── RIGHT: Device picker + (conditional) upload + controls ──────────── -->
    <div class="right-panel">

      <ze-apk-upload
        [step]="step"
        [appType]="appType"
        [errorMessage]="errorMessage"
        [selectedDevice]="session.selectedDevice"
        (uploadComplete)="onUploadComplete($event)"
        (uploadError)="onUploadError($event)"
        (errorDismissed)="onErrorDismissed()"
        (appTypeChanged)="onAppTypeChanged($event)"
        (deviceSelected)="onDeviceSelected($event)">
      </ze-apk-upload>

      <!-- Divider + gesture controls — only shown once a device is selected -->
      <ng-container *ngIf="session.selectedDevice">
        <div class="panel-divider"></div>
        <ze-gesture-controls
          #gestureControls
          [fingerMode]="fingerMode"
          [selectedMode]="selectedMode"
          [isRecording]="isRecording"
          [existingSteps]="recordedSteps"
          (fingerModeChanged)="onFingerModeChanged($event)"
          (modeChanged)="onModeChanged($event)"
          (recordingStarted)="onRecordingStarted($event)"
          (recordingResumed)="onRecordingResumed($event)"
          (recordingPaused)="onRecordingPaused()"
          (recordingStopped)="onRecordingStopped()"
          (newStepStarted)="onNewStepStarted($event)"
          (modalOpenChange)="isModalOpen = $event"
          (typeConfirmed)="onTypeConfirmed($event)"
          (typeCancelled)="gestureControls.cancelType()"
          (clearAndTypeConfirmed)="onClearAndTypeConfirmed($event)">
        </ze-gesture-controls>
      </ng-container>

      <!-- Placeholder hint when no device is selected yet -->
      <div class="no-device-hint" *ngIf="!session.selectedDevice">
        <p class="no-device-text">Select a device above to continue</p>
      </div>

    </div>
  </div>
</div>